"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainScopes = exports.OrderTransactionEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["OrderTransactionEvent"] = "OrderTransactionEvent";
    EventTypes["OrderHeaderEvent"] = "OrderHeaderEvent";
    EventTypes["OrderDetailEvent"] = "OrderDetailEvent";
    EventTypes["OrderDetailSuppEvent"] = "OrderDetailSuppEvent";
    EventTypes["SubmitIpOrderEvent"] = "SubmitIpOrderEvent";
    EventTypes["OrderLightwaveEvent"] = "OrderLightwaveEvent";
    EventTypes["OrderExceptionEvent"] = "OrderExceptionEvent";
    EventTypes["UpdateSubmittedOrderEvent"] = "UpdateSubmittedOrderEvent";
    EventTypes["CancelOrderEvent"] = "CancelOrderEvent";
    EventTypes["ConvertToWillCallEvent"] = "ConvertToWillCallEvent";
    EventTypes["ShipToConversionEvent"] = "ShipToConversionEvent";
    EventTypes["DirectOrderStatus"] = "DirectOrderStatus";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var OrderTransactionEventActions;
(function (OrderTransactionEventActions) {
    OrderTransactionEventActions["OrderTransactionCreated"] = "OrderTransactionCreated";
    OrderTransactionEventActions["OrderTransactionUpdated"] = "OrderTransactionUpdated";
    OrderTransactionEventActions["OrderTransactionDeleted"] = "OrderTransactionDeleted";
    OrderTransactionEventActions["OrderHeaderEventUpdated"] = "OrderHeaderEventUpdated";
    OrderTransactionEventActions["OrderHeaderEventCreated"] = "OrderHeaderEventCreated";
    OrderTransactionEventActions["OrderDetailEventCreated"] = "OrderDetailEventCreated";
    OrderTransactionEventActions["OrderDetailEventUpdated"] = "OrderDetailEventUpdated";
    OrderTransactionEventActions["OrderDetailEventDeleted"] = "OrderDetailEventDeleted";
    OrderTransactionEventActions["OrderDetailSuppEventCreated"] = "OrderDetailSuppEventCreated";
    OrderTransactionEventActions["OrderDetailSuppEventUpdated"] = "OrderDetailSuppEventUpdated";
    OrderTransactionEventActions["OrderDetailSuppEventDeleted"] = "OrderDetailSuppEventDeleted";
    OrderTransactionEventActions["OrderLightwaveEventUpdated"] = "OrderLightwaveEventUpdated";
    OrderTransactionEventActions["OrderExceptionEventUpdated"] = "OrderExceptionEventUpdated";
    OrderTransactionEventActions["SubmitIpOrder"] = "SubmitIpOrder";
    OrderTransactionEventActions["UpdateSubmittedOrder"] = "UpdateSubmittedOrder";
    OrderTransactionEventActions["CancelOrder"] = "CancelOrder";
    OrderTransactionEventActions["SubmitIpSplitOrder"] = "SubmitIpSplitOrder";
    OrderTransactionEventActions["CreateOrderTransaction"] = "CreateOrderTransaction";
    OrderTransactionEventActions["UpdateOrderTransaction"] = "UpdateOrderTransaction";
    OrderTransactionEventActions["DeleteOrderTransaction"] = "DeleteOrderTransaction";
    OrderTransactionEventActions["CreateOrderAudit"] = "CreateOrderAudit";
    OrderTransactionEventActions["ConvertToWillCall"] = "ConvertToWillCall";
    OrderTransactionEventActions["VendorCancelled"] = "VendorCancelled";
    OrderTransactionEventActions["ShipToConversion"] = "ShipToConversion";
})(OrderTransactionEventActions = exports.OrderTransactionEventActions || (exports.OrderTransactionEventActions = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyOrderTransactions"] = "MyOrderTransactions";
})(DomainScopes = exports.DomainScopes || (exports.DomainScopes = {}));
